import { Box, Button, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import KitModal from '../../../UI/KitModal';

interface RenameAssetModalProps {
  show: boolean;
  currentName: string;
  assetType: string;
  onHide: () => void;
  onRename: (newName: string) => void;
}

export const RenameAssetModal: React.FC<RenameAssetModalProps> = ({
  show,
  currentName,
  assetType,
  onHide,
  onRename,
}) => {
  const [name, setName] = useState(currentName);

  useEffect(() => {
    setName(currentName);
  }, [currentName]);

  const handleSubmit = (e?: React.FormEvent) => {
    e?.preventDefault();
    if (!name.trim()) return;
    onRename(name.trim());
  };

  return (
    <KitModal
      onHide={onHide}
      show={show}
      title={`Rename ${assetType}`}
      sx={{
        '& .MuiPaper-root': {
          maxWidth: '450px',
          width: '100%',
        },
      }}
    >
      <form onSubmit={handleSubmit}>
        <Box
          display='flex'
          flexDirection='column'
          justifyContent='space-between'
          gap='1rem'
        >
          <TextField
            label={`Enter ${assetType.toLowerCase()} name`}
            variant='outlined'
            type='text'
            value={name}
            onChange={e => setName(e.target.value)}
            fullWidth
            autoFocus
          />
          <Box alignSelf='flex-end'>
            <Button
              disabled={!name.trim()}
              onClick={handleSubmit}
              variant='contained'
              size='small'
            >
              Confirm
            </Button>
          </Box>
        </Box>
      </form>
    </KitModal>
  );
};
